import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "scheme-editor" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_3 = { class: "row g-3 scheme-editor__layout" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "scheme-editor__grid",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "none",
  "aria-hidden": "true"
}
const _hoisted_6 = ["x1", "x2"]
const _hoisted_7 = ["y1", "y2"]
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = {
  key: 1,
  class: "scheme-marker__label"
}
const _hoisted_11 = { class: "scheme-marker__name font-monospace" }
const _hoisted_12 = { class: "scheme-marker__value" }
const _hoisted_13 = {
  key: 2,
  class: "scheme-marker__label"
}
const _hoisted_14 = { class: "scheme-marker__name" }
const _hoisted_15 = { class: "scheme-marker__value" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "scheme-editor__zoom-controls" }
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "scheme-editor__readout font-monospace" }
const _hoisted_22 = { class: "scheme-editor__hint" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "scheme-editor__side" }
const _hoisted_25 = { class: "scheme-panel" }
const _hoisted_26 = { class: "scheme-panel__header" }
const _hoisted_27 = { class: "scheme-panel__title" }
const _hoisted_28 = {
  key: 0,
  class: "scheme-editor__mode-switch mb-3"
}
const _hoisted_29 = {
  key: 1,
  class: "asset-select-wrapper position-relative"
}
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "asset-dropdown-results"
}
const _hoisted_33 = {
  key: 0,
  class: "dropdown-item text-muted"
}
const _hoisted_34 = ["onMousedown"]
const _hoisted_35 = { class: "asset-name" }
const _hoisted_36 = {
  key: 0,
  class: "text-muted ms-2"
}
const _hoisted_37 = {
  key: 2,
  class: "asset-select-wrapper position-relative"
}
const _hoisted_38 = { class: "input-group" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = {
  key: 0,
  class: "asset-dropdown-results"
}
const _hoisted_41 = {
  key: 0,
  class: "dropdown-item text-muted"
}
const _hoisted_42 = ["onMousedown"]
const _hoisted_43 = { class: "asset-name font-monospace" }
const _hoisted_44 = {
  key: 0,
  class: "scheme-panel"
}
const _hoisted_45 = { class: "scheme-panel__header" }
const _hoisted_46 = { class: "scheme-panel__title" }
const _hoisted_47 = { class: "scheme-editor__table-wrap" }
const _hoisted_48 = { class: "table table-sm scheme-editor__table" }
const _hoisted_49 = { class: "font-monospace" }
const _hoisted_50 = ["value", "onInput"]
const _hoisted_51 = ["value", "onInput"]
const _hoisted_52 = ["value", "onInput"]
const _hoisted_53 = ["title", "onClick"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  colspan: "5",
  class: "scheme-editor__table-empty"
}
const _hoisted_56 = { class: "scheme-editor__panel-hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.canvasColClass)
      }, [
        _createElementVNode("div", {
          ref: "canvasRef",
          class: _normalizeClass(["scheme-editor__canvas", { 'scheme-editor__canvas--panning': _ctx.isPanning }]),
          onMousedown: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startPan && _ctx.startPan(...args)), ["prevent"])),
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleCanvasClick && _ctx.handleCanvasClick(...args)))
        }, [
          _createElementVNode("div", {
            ref: "frameRef",
            class: _normalizeClass(["scheme-editor__frame", { 'scheme-editor__frame--blank': !_ctx.schemeImage }]),
            style: _normalizeStyle(_ctx.frameStyle)
          }, [
            _createElementVNode("div", {
              class: "scheme-editor__zoomable",
              style: _normalizeStyle(_ctx.zoomableStyle)
            }, [
              (_ctx.schemeImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.schemeImage,
                    class: "scheme-editor__image",
                    alt: "Scheme",
                    draggable: "false",
                    onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args)))
                  }, null, 40, _hoisted_4))
                : _createCommentVNode("", true),
              (_ctx.hasMetricCalibration)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridTicksX, (x) => {
                      return (_openBlock(), _createElementBlock("line", {
                        key: `gx${x}`,
                        x1: _ctx.pctX(x),
                        y1: "0",
                        x2: _ctx.pctX(x),
                        y2: "100"
                      }, null, 8, _hoisted_6))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridTicksY, (y) => {
                      return (_openBlock(), _createElementBlock("line", {
                        key: `gy${y}`,
                        x1: "0",
                        y1: _ctx.pctY(y),
                        x2: "100",
                        y2: _ctx.pctY(y)
                      }, null, 8, _hoisted_7))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasMetricCalibration)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridTicksX, (x) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `tx${x}`,
                        class: "scheme-editor__tick scheme-editor__tick--x",
                        style: _normalizeStyle({ left: _ctx.pctX(x) + '%' })
                      }, _toDisplayString(x), 5))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridTicksY, (y) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `ty${y}`,
                        class: "scheme-editor__tick scheme-editor__tick--y",
                        style: _normalizeStyle({ top: _ctx.pctY(y) + '%' })
                      }, _toDisplayString(y), 5))
                    }), 128)),
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "scheme-editor__origin-label" }, "0,0", -1))
                  ], 64))
                : _createCommentVNode("", true)
            ], 4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markersState, (marker, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${marker.type}-${marker.type === 'anchor' ? marker.address : marker.assetId}-${idx}`,
                class: _normalizeClass(["scheme-marker", { 'scheme-marker--anchor': marker.type === 'anchor' }]),
                style: _normalizeStyle(_ctx.markerStyle(marker)),
                onMousedown: _withModifiers(($event: any) => (_ctx.startDrag(idx, $event)), ["stop","prevent"])
              }, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "scheme-marker__dot" }, null, -1)),
                (!_ctx.readOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "scheme-marker__remove",
                      onMousedown: _withModifiers(($event: any) => (_ctx.removeMarker(idx)), ["stop","prevent"])
                    }, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                    ]))], 40, _hoisted_9))
                  : _createCommentVNode("", true),
                (marker.type === 'anchor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(marker.address), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "bi bi-reception-4" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.getAnchorRssi(marker.address)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getAssetLabel(marker.assetId)), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[30] || (_cache[30] = _createElementVNode("i", {
                          class: "bi bi-thermometer-half",
                          style: {"color":"#e74c3c"}
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.getTemperature(marker.assetId)) + " ", 1),
                        (_ctx.getHumidity(marker.assetId) !== null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _cache[28] || (_cache[28] = _createTextVNode("  · ", -1)),
                              _cache[29] || (_cache[29] = _createElementVNode("i", {
                                class: "bi bi-droplet-half",
                                style: {"color":"#3498db"}
                              }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.getHumidity(marker.assetId)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ], 46, _hoisted_8))
            }), 128))
          ], 6),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              class: "scheme-editor__zoom-btn",
              title: _ctx.$t('components.assetSchemes.editor.zoomIn'),
              onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.zoomBy(1.3)), ["stop"]))
            }, [...(_cache[32] || (_cache[32] = [
              _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
            ]))], 40, _hoisted_18),
            _createElementVNode("button", {
              type: "button",
              class: "scheme-editor__zoom-btn",
              title: _ctx.$t('components.assetSchemes.editor.zoomOut'),
              onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.zoomBy(1 / 1.3)), ["stop"]))
            }, [...(_cache[33] || (_cache[33] = [
              _createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1)
            ]))], 40, _hoisted_19),
            _createElementVNode("button", {
              type: "button",
              class: "scheme-editor__zoom-btn",
              title: _ctx.$t('components.assetSchemes.editor.zoomReset'),
              onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetZoom && _ctx.resetZoom(...args)), ["stop"]))
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "bi bi-arrow-counterclockwise" }, null, -1)
            ]))], 40, _hoisted_20)
          ]),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.readout || _ctx.$t('components.assetSchemes.editor.dragHint')), 1),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.hasMetricCalibration ? _ctx.$t('components.assetSchemes.editor.originHintMetric') : _ctx.$t('components.assetSchemes.editor.originHintPercent')), 1)
        ], 34)
      ], 2),
      (!_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.sideColClass)
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "scheme-editor__side-toggle",
              title: _ctx.sidebarCollapsed ? _ctx.$t('components.assetSchemes.editor.expandPanel') : _ctx.$t('components.assetSchemes.editor.collapsePanel'),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sidebarCollapsed = !_ctx.sidebarCollapsed))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["bi", _ctx.sidebarCollapsed ? 'bi-chevron-left' : 'bi-chevron-right'])
              }, null, 2)
            ], 8, _hoisted_23),
            _withDirectives(_createElementVNode("div", _hoisted_24, [
              _renderSlot(_ctx.$slots, "side-top", {}, undefined, true),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi scheme-panel__icon", _ctx.pickerMode === 'asset' ? 'bi-box-seam' : 'bi-broadcast'])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.pickerMode === 'asset' ? _ctx.$t('components.assetSchemes.editor.modeAsset') : _ctx.$t('components.assetSchemes.editor.modeAnchor')), 1)
                ]),
                (_ctx.hasAssets && _ctx.hasAnchors)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["tab-link", { active: _ctx.pickerMode === 'asset' }]),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pickerMode = 'asset'))
                      }, _toDisplayString(_ctx.$t('components.assetSchemes.editor.modeAsset')), 3),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["tab-link", { active: _ctx.pickerMode === 'anchor' }]),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.pickerMode = 'anchor'))
                      }, _toDisplayString(_ctx.$t('components.assetSchemes.editor.modeAnchor')), 3)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pickerMode === 'asset')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "input-group-text" }, [
                          _createElementVNode("i", { class: "bi bi-box-seam" })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.assetSearch) = $event)),
                          type: "text",
                          class: "form-control",
                          placeholder: _ctx.$t('components.assetSchemes.editor.selectAssetPlaceholder'),
                          autocomplete: "off",
                          onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showAssetDropdown = true)),
                          onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onAssetSearch && _ctx.onAssetSearch(...args))),
                          onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onAssetBlur && _ctx.onAssetBlur(...args)))
                        }, null, 40, _hoisted_31), [
                          [_vModelText, _ctx.assetSearch]
                        ]),
                        (_ctx.assetSearch)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-outline-secondary",
                              onMousedown: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearAssetSearch && _ctx.clearAssetSearch(...args)), ["prevent"]))
                            }, [...(_cache[35] || (_cache[35] = [
                              _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                            ]))], 32))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary",
                          onMousedown: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAssetDropdown && _ctx.toggleAssetDropdown(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi", _ctx.showAssetDropdown ? 'bi-chevron-up' : 'bi-chevron-down'])
                          }, null, 2)
                        ], 32)
                      ]),
                      (_ctx.showAssetDropdown)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_ctx.filteredAssets.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _cache[37] || (_cache[37] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.noAvailableAssets')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAssets, (asset) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: asset.id,
                                class: "dropdown-item asset-dropdown-item",
                                onMousedown: _withModifiers(($event: any) => (_ctx.selectAsset(asset)), ["prevent"])
                              }, [
                                _cache[38] || (_cache[38] = _createElementVNode("i", { class: "bi bi-plus-circle me-2 text-success" }, null, -1)),
                                _createElementVNode("span", _hoisted_35, _toDisplayString(asset.name || asset.serialNumber || asset.serial_number), 1),
                                (asset.serialNumber || asset.serial_number)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_36, " (" + _toDisplayString(asset.serialNumber || asset.serial_number) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ], 40, _hoisted_34))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "input-group-text" }, [
                          _createElementVNode("i", { class: "bi bi-broadcast" })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.anchorSearch) = $event)),
                          type: "text",
                          class: "form-control",
                          placeholder: _ctx.$t('components.assetSchemes.editor.selectAnchorPlaceholder'),
                          autocomplete: "off",
                          onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showAnchorDropdown = true)),
                          onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onAnchorSearch && _ctx.onAnchorSearch(...args))),
                          onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onAnchorBlur && _ctx.onAnchorBlur(...args)))
                        }, null, 40, _hoisted_39), [
                          [_vModelText, _ctx.anchorSearch]
                        ]),
                        (_ctx.anchorSearch)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-outline-secondary",
                              onMousedown: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearAnchorSearch && _ctx.clearAnchorSearch(...args)), ["prevent"]))
                            }, [...(_cache[39] || (_cache[39] = [
                              _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                            ]))], 32))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary",
                          onMousedown: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAnchorDropdown && _ctx.toggleAnchorDropdown(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi", _ctx.showAnchorDropdown ? 'bi-chevron-up' : 'bi-chevron-down'])
                          }, null, 2)
                        ], 32)
                      ]),
                      (_ctx.showAnchorDropdown)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_ctx.filteredAnchors.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _cache[41] || (_cache[41] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetSchemes.editor.noAvailableAnchors')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAnchors, (anchor) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: anchor.address,
                                class: "dropdown-item asset-dropdown-item",
                                onMousedown: _withModifiers(($event: any) => (_ctx.selectAnchor(anchor)), ["prevent"])
                              }, [
                                _cache[42] || (_cache[42] = _createElementVNode("i", { class: "bi bi-plus-circle me-2 text-success" }, null, -1)),
                                _createElementVNode("span", _hoisted_43, _toDisplayString(anchor.address), 1)
                              ], 40, _hoisted_42))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              (_ctx.pickerMode === 'anchor' && _ctx.hasMetricCalibration)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[43] || (_cache[43] = _createElementVNode("i", { class: "bi bi-rulers scheme-panel__icon" }, null, -1)),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.anchorsTableTitle')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("table", _hoisted_48, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.address')), 1),
                            _cache[44] || (_cache[44] = _createElementVNode("th", null, "X (m)", -1)),
                            _cache[45] || (_cache[45] = _createElementVNode("th", null, "Y (m)", -1)),
                            _cache[46] || (_cache[46] = _createElementVNode("th", null, "Z (m)", -1)),
                            _cache[47] || (_cache[47] = _createElementVNode("th", null, null, -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anchorMarkersState, (marker) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: marker.address
                            }, [
                              _createElementVNode("td", _hoisted_49, _toDisplayString(marker.address), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("input", {
                                  type: "number",
                                  step: "0.1",
                                  class: "form-control form-control-sm",
                                  value: marker.x,
                                  onInput: ($event: any) => (_ctx.updateAnchorCoord(marker.address, 'x', $event))
                                }, null, 40, _hoisted_50)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("input", {
                                  type: "number",
                                  step: "0.1",
                                  class: "form-control form-control-sm",
                                  value: marker.y,
                                  onInput: ($event: any) => (_ctx.updateAnchorCoord(marker.address, 'y', $event))
                                }, null, 40, _hoisted_51)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("input", {
                                  type: "number",
                                  step: "0.1",
                                  class: "form-control form-control-sm",
                                  value: marker.z ?? 2.5,
                                  onInput: ($event: any) => (_ctx.updateAnchorCoord(marker.address, 'z', $event))
                                }, null, 40, _hoisted_52)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "scheme-editor__row-remove",
                                  title: _ctx.$t('components.assetSchemes.editor.calibration.remove'),
                                  onClick: ($event: any) => (_ctx.removeMarkerByAddress(marker.address))
                                }, [...(_cache[48] || (_cache[48] = [
                                  _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                                ]))], 8, _hoisted_53)
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.anchorMarkersState.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                                _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.noAnchorsPlaced')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.tableHint')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !_ctx.sidebarCollapsed]
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}